import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteContactMessage,
  listContactMessages,
  updateContactMessageStatus,
} from "../../actions/contactActions";
import {
  CONTACT_DELETE_RESET,
  CONTACT_UPDATE_STATUS_RESET,
} from "../../constants/contactConstants";

const AdminContactListScreen = () => {
  const dispatch = useDispatch();

  const contactList = useSelector((state) => state.contactList);
  const { loading, error, contacts } = contactList;

  const contactDelete = useSelector((state) => state.contactDelete);
  const {
    success: successDelete,
    error: errorDelete,
    loading: loadingDelete,
  } = contactDelete;

  const contactUpdateStatus = useSelector((state) => state.contactUpdateStatus);
  const {
    success: successStatus,
    error: errorStatus,
    loading: loadingStatus,
  } = contactUpdateStatus;

  useEffect(() => {
    if (successDelete) {
      dispatch({ type: CONTACT_DELETE_RESET });
    }

    if (successStatus) {
      dispatch({ type: CONTACT_UPDATE_STATUS_RESET });
    }

    dispatch(listContactMessages());
  }, [dispatch, successDelete, successStatus]);

  const deleteHandler = (id) => {
    if (window.confirm("Are you sure you want to delete this message?")) {
      dispatch(deleteContactMessage(id));
    }
  };

  const statusHandler = (id, currentStatus) => {
    const nextStatus = currentStatus === "resolved" ? "new" : "resolved";
    dispatch(updateContactMessageStatus(id, nextStatus));
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4">Contact Messages</h2>

      {loadingDelete && <p>Deleting...</p>}
      {errorDelete && <p className="text-danger">{errorDelete}</p>}

      {loadingStatus && <p>Updating status...</p>}
      {errorStatus && <p className="text-danger">{errorStatus}</p>}

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-danger">{error}</p>
      ) : contacts.length === 0 ? (
        <p>No contact messages found.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Subject</th>
                <th>Message</th>
                <th>Status</th>
                <th>Date</th>
                <th style={{ width: "180px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((contact) => (
                <tr key={contact._id}>
                  <td>{contact.name}</td>
                  <td>{contact.email}</td>
                  <td>{contact.subject || "-"}</td>
                  <td style={{ maxWidth: "280px" }}>
                    <div
                      title={contact.message}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {contact.message}
                    </div>
                  </td>
                  <td>
                    <span
                      className={`badge ${
                        contact.status === "resolved"
                          ? "bg-success"
                          : "bg-warning text-dark"
                      }`}
                    >
                      {contact.status}
                    </span>
                  </td>
                  <td>{new Date(contact.createdAt).toLocaleString()}</td>
                  <td>
                    <div className="d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() =>
                          statusHandler(contact._id, contact.status)
                        }
                      >
                        {contact.status === "resolved" ? "Mark New" : "Resolve"}
                      </button>

                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => deleteHandler(contact._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminContactListScreen;
